import * as Config from '../../config';
import Locale from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";


export class NotUpToSpeed extends AlertLogic {
    static type = AlertType.NotUpToSpeed;
    static category = AlertCategories.EQUIPMENT_FAILURE;
    static contentCategories = [ ContentCategories.SYSTEM_ERROR ];
    static title = Locale.gettext('Not up to speed');

    getInfo(timeZone?: string): AlertInfo {
        const alert = this.alert;
        const config = this.allConfigs;
        
        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(timeZone);
        
        // Varying across alert types
        let detailIcon = 'pump';

        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Pump issue'),
            cardDescription: this.locale.gettext('%1$s cannot reach the desired speed of %2$s%%', device.Name, alertData?.DesiredSpeed),
            cardIllustration: 'pipes_emergency',
            detailIcon: detailIcon,
            //detailTitle: this.locale.gettext('Device not responding'),
            detailDescription: this.locale.gettext('The desired speed of %3$s%% for %1$s %2$s was never reached. The current speed is %4$s%%.', 
                device.Name, 
                device.HardwareDevice?.UniqueBusIdentifier ? '(Serial port: ' + device.HardwareDevice?.Ports[0]?.Number + ', Bus ID : ' + device.HardwareDevice?.UniqueBusIdentifier + ')' : '',
                alertData?.DesiredSpeed,
                alertData?.ActualSpeed),
            detailDescription2: this.locale.gettext('The issue started %1$s.',
                alertData?.LastDesiredSpeedPercentDateTime ?
                    this.locale.formatTimeHumanFriendy(new Date(alertData.LastDesiredSpeedPercentDateTime), undefined, undefined, true) :
                    this.locale.gettext('at an unknown time')
            ),
            actionButtonTitle: false,
            resolveSummary: this.locale.gettext('%1$s speed issue resolved', device.Name)
        });
        alertInfo.contentCategories = NotUpToSpeed.contentCategories;
        return alertInfo;
    }

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord {
        let device = config.Config.Devices.find(dev => dev.DeviceType === "Pump");
        
        return device ? new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            deviceId: 1,
            entityUuid: device?.UUID,
            bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
            type: type,
            data: {
                OfflineDateTime: new Date(Date.now() - 60*60*1000),
                LastDesiredSpeedPercentDateTime: new Date(Date.now() - 2*60*60*1000),
                DesiredSpeed: 85,
                ActualSpeed: 60
            }
        }) : null;
    }
}